import React, { FC, PropsWithChildren } from 'react';
import { Row, Col } from 'antd';
import { JCMSCTA, JCMSCTAProps } from '../JCMSCTA';
import { CMSCTA } from '../models';


export type JCMSListCTAProps = {
    cta: CMSCTA[];
    action?: (cta: CMSCTA) => void,
}

export const JCMSListCTA: FC<PropsWithChildren<JCMSListCTAProps>> = (props) => {
   
    return (
        <Row className='btnContainer' justify={'center'} align={'middle'} gutter={24}>
                {props.cta?.map((cta: JCMSCTAProps, i: number) => {
                    return (
                        <Col key={i}>
                            <JCMSCTA {...cta} action={ props.action || cta?.action}  />
                        </Col>
                    )
                })}
            </Row>
    )
}

